import {
  FLOATING_BOTTOM_CHROME_PX,
  belowStickyChromeClearancePx,
} from "@/lib/sticky-chrome-offsets";

/**
 * Brings an element out from under the sticky chrome, the transits hubs' rule
 * (src/lib/answer-into-view.ts), kept in this route so
 * the page owns every file it renders. Used for the picker's result panel
 * once the Moon-sign check has selected a sign: the panel carries the
 * chrome's scroll margin (BELOW_STICKY_CHROME_SCROLL_MARGIN), so "start" lands
 * it just below the chrome. An element whose top is already clear of the
 * chrome and on screen stays put.
 */
export function bringIntoView(element: HTMLElement | null): void {
  if (!element) return;
  const { top, width, height } = element.getBoundingClientRect();
  if (width === 0 && height === 0) return;
  const clearOfChrome =
    top >= belowStickyChromeClearancePx() && top <= window.innerHeight - FLOATING_BOTTOM_CHROME_PX;
  if (!clearOfChrome) element.scrollIntoView({ block: "start", behavior: "auto" });
}
